import { render, staticRenderFns } from "./AirlineName.vue?vue&type=template&id=7210cd85&"
import script from "./AirlineName.vue?vue&type=script&lang=js&"
export * from "./AirlineName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports